import { watch } from 'vue';
import { fetchUserSettings } from '~/api/userSettings';
import { adoptServerAppearance, appearanceRevision, initAppearance } from '~/composables/useAppearance';
import { useUsersStore } from '~/stores/users';

export default defineNuxtPlugin(() => {
  initAppearance();

  const users = useUsersStore();
  watch(() => users.authUserData?.id, async (userId) => {
    if (userId === undefined) { return; }
    try {
      const revision = appearanceRevision();
      adoptServerAppearance((await fetchUserSettings()).appearance, revision);
    } catch (error) {
      console.error('[appearance] settings', error);
    }
  });
});
